import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { TransitionGroup } from 'react-transition-group'
import _ from 'lodash'
import ScrollArea from 'react-scrollbar'
import ReactHtmlParser from 'react-html-parser'

import { fetchPageIfNeeded, fetchCustomPostsIfNeeded, fetchSiteOptions } from '../actions'
import { DEFAULT_PAGE } from '../reducers/pages'
import { DEFAULT_CUSTOM_POST } from '../reducers/customposts'
import { DEFAULT_SITE_OPTIONS } from '../reducers/siteoptions'
import { withRouter } from 'react-router'
import ContactForm from '../components/ContactForm'
import {SlideFromRight} from '../components/Transitions'

class Offerte extends Component {
    componentWillMount() {
        const { fetchPageIfNeeded, fetchCustomPostsIfNeeded, fetchSiteOptions } = this.props
        fetchPageIfNeeded('offerte')
        fetchCustomPostsIfNeeded('trainingen')
        fetchSiteOptions()
    }
    render() {
        const { page, posts, selectedTraining, location, siteoptions } = this.props
        return (
            <TransitionGroup>
                {!_.isEmpty(location.hash) && 
                    <SlideFromRight>
                        <ScrollArea
                            speed={0.8}
                            className="page offerte fixed"
                            contentClassName="grid-container fluid"
                            horizontal={false}>
                            <div className="grid-x grid-margin-x align-center">
                                <div className="cell auto">
                                    <div className="wrap">
                                        <Link className="close" to={location.pathname}><i className="material-icons">close</i></Link>
                                        <h1>{ReactHtmlParser(page.title.rendered)}</h1>
                                        <ContactForm trainingen={posts} selected={selectedTraining} content={page.content.rendered} formId={siteoptions.form_id}/>
                                    </div>
                                </div>
                            </div>
                        </ScrollArea>
                    </SlideFromRight>}
            </TransitionGroup>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const page = state.pages['offerte'] || state.pages[DEFAULT_PAGE]
    const posts = state.customposts['trainingen'] || state.customposts[DEFAULT_CUSTOM_POST]
    const siteoptions = state.siteoptions['siteoptions'] || state.siteoptions[DEFAULT_SITE_OPTIONS]
    // const selectedTraining = qs.parse(ownProps.location.search.substring(1)).training || ''
    const selectedTraining = ownProps.location.pathname.split('/').pop() || ''
    return {
        page: page,
        posts: posts,
        selectedTraining: selectedTraining,
        siteoptions: siteoptions,
    }
}

export default withRouter(connect(mapStateToProps,{ fetchPageIfNeeded, fetchCustomPostsIfNeeded, fetchSiteOptions })(Offerte))


// WEBPACK FOOTER //
// ./src/pages/Offerte.js